import React from "react";
import { Button, Col, FormLabel, Row, Table } from "react-bootstrap";
import { AppContext } from "../AppContext.js";
import { NEW_ENTRY } from "../ds/App_Constants.js";
import { BaseBean, NodeData } from "../ds/client_ds.js";
import {
  BankAccountSearchCriteria,
  LetterOfCreditBean,
  LetterOfCreditDetailBean,
  LetterOfCreditSearchCriteria,
  PageListBean,
  PurchaseOrderSearchCriteria,
  RestEntityUnLockRequest,
  RestLetterOfCreditListRequest,
  RestPurchaseOrderListRequest,
  RestReadRequest,
  RestVendorListRequest,
  VendorSearchCriteria,
} from "../ds/ds.js";
import { AddIcon, DropDwnDown, DropDwnUp } from "../gui_components/Icons.js";
import {
  AlertToolBox,
  ColumnDefinition,
  DatePickerComponent,
  InputTextbox,
  MultiViewPopup,
  NumberFormatInputbox,
  ProgressBar,
  ShowError,
} from "../gui_components/UIComponents.js";
import {
  isEmpty,
  isEmptyArray,
  isEmptyString,
} from "../gui_components/Util.js";
import { GenericAttributeLookupHandler } from "../lookup/GenericAttributeLookupHandler.js";
import { LetterOfCreditLookupHandler } from "../lookup/LetterOfCreditLookupHandler.js";
import { PurchaseOrderLookupHandler } from "../lookup/PurchaseOrderLookupHandler.js";
import { VendorLookupHandler } from "../lookup/VendorLookupHandler.js";
import { SecurityAccessManager } from "../security/SecurityAccessManager.js";
import { AccountPayableService } from "../services/AccountPayableService.js";
import { MasterService } from "../services/MasterService.js";
import { PurchaseOrderService } from "../services/PurchaseOrderService.js";
import { VendorService } from "../services/VendorService.js";
import { BaseNodeBar, BaseToolBar, ModuleToolBar } from "./BaseModule.js";
import { ModuleUtils } from "./ModuleUtils.js";
import { AlignStartVertical } from "lucide-react";
import CustomTable from "../gui_components/CustomTable.js";
class LetterOfCreditList extends React.Component {
  static contextType = AppContext;
  constructor(props) {
    super(props);
    this.state = {
      pageTitle: "Letter Of Credit",
      isListFormOpen: false,
      isEntryFormOpen: false,
      isShowNodes: true,
      isShowSaveButton: false,
      isShowClearCriteriaButton: false,
      isShowClearErrorButton: false,
      isShowModuleSearchContainer: true,
      letterOfCreditLookupHandler: null,
      moduleKeyCode: NEW_ENTRY,
      isResetModule: false,
      isReadOnlyOrDisabled: false,
      isDisabledFields: false,
      isSpecialViewMode: false,
      alertMessage: [],
      alertType: "",
      isShowAlert: false,
      isShowAlertLvl5: false,
      disabled: false,
      isResetView: true,
      error_list: [],
      nodeList: new Array(),
      selectedNodeKey: "headerView",
      locList: new Array(),
      criteria: new LetterOfCreditSearchCriteria(),
      pageList: new PageListBean(),
      order: "asc",
      sortField: "",
      locData: new LetterOfCreditBean(),
      locLinesData: [],
      locCreditData: new LetterOfCreditDetailBean(),
      isShowLocPopup: false,
      banks: [],
      isShowAutoCompleteVendorList: false,
      vendorPageListForAutoCompleteList: new Array(),
      isShowAutoCompleteBankList: false,
      bankPageListForAutoCompleteList: new Array(),
      isShowAutoCompletePurchaseOrderList: false,
      purchaseOrderPageListForAutoCompleteList: new Array(),
      isShowProgressBarPopup: false,
      progressLoadingText: "",
      moduleOrderStatus: "",
      isMaintenanceMode: true,
      isReseted: false,
      isViewMode: false,
    };
  }
  componentDidMount() {
    const { appData } = this.context;
    this.moduleCaption = "Letter Of Credit";
    this.companyCode = appData.companyCode;
    this.state.criteria.companyCode = this.companyCode;
    const { cache } = appData;
    this.cache = cache;
    this.state.pageList = new PageListBean();
    this.state.pageList.pageSize = 50;
    ModuleUtils.getLetterOfCreditStatusList();
    let isReadOnly = this.state.isReadOnlyOrDisabled;
    let isSpecialViewMode = this.state.isSpecialViewMode;
    if (this.props.isSpecialViewMode) {
      isSpecialViewMode = this.props.isSpecialViewMode;
      isReadOnly = this.props.isSpecialViewMode;
    }
    this.setState({
      isReadOnlyOrDisabled: isReadOnly,
      isSpecialViewMode: isSpecialViewMode,
    });
    if (this.props.code !== "" && this.props.code !== undefined) {
      this.code = this.props.code;
      // this.unlockLoc(this.props.code);
      this.editLoc(this.props.code);
      this.setState({
        isResetView: false,
        isMaintenanceMode: false,
        isDisabledFields: true,
        isViewMode: false,
      });
    } else {
      this.addNewEntry();
    }
    this.initLookupHandler();
    this.loadCache();
  }
  initLookupHandler = () => {
    let letterOfCreditLookupHandler = new LetterOfCreditLookupHandler(
      this.companyCode,
      "Letter Of Credits",
    );
    this.setState({ letterOfCreditLookupHandler: letterOfCreditLookupHandler });
  };
  loadCache = () => {
    const attribute_cache = { ...this.cache };
    // let attribute_cache = JSON.parse(localStorage.getItem("attributeCache"));
    let banks = [];
    let bank_temp = [];
    if (!isEmptyArray(attribute_cache))
      attribute_cache.bankAccounts.map((ln) => {
        bank_temp.push(ln);
        banks = ModuleUtils.isActiveAttribute(bank_temp);
      });
    this.setState({ banks: banks });
  };
  addNewEntry = () => {
    let locData = new LetterOfCreditBean();
    locData.companyCode = this.companyCode;
    locData.letterOfCreditNumber = NEW_ENTRY;
    locData.status = "O";
    let createdDate = new Date();
    createdDate = createdDate.toLocaleDateString("sv-SE");
    locData.letterOfCreditDate = createdDate;
    if (
      !isEmptyString(this.state.moduleKeyCode) ||
      this.state.moduleKeyCode != NEW_ENTRY
    )
      locData.letterOfCreditNumber = this.state.moduleKeyCode;
    else locData.letterOfCreditNumber = NEW_ENTRY;
    let pageTitle = this.moduleCaption + " - NEW";

    if (this.state.moduleKeyCode == NEW_ENTRY) {
      this.isLocked = false;
    } else {
      this.isLocked = true;
    }
    this.setState({
      locData: locData,
      pageTitle: pageTitle,
      locLinesData: new Array(),
      selectedNodeKey: "headerView",
    });
    this.state.locData = locData;
    this.openEntryForm();
  };
  openEntryForm() {
    this.closeAllNodeViews();
    this.getNodeList();

    this.setState({
      isEntryFormOpen: true,
      isListFormOpen: false,
      isShowSaveButton: true,
      isShowApproveButton: true,
      isShowClearCriteriaButton: false,
      isShowClearErrorButton: false,
      isShowBackButton: true,
      isShowNodes: true,
      isShowModuleSearchContainer: true,
      disabled: false,
      isDisabledFields: false,
    });
    if (this.state.isSpecialViewMode == false) {
      this.setState({
        isResetView: true,
        isMaintenanceMode: true,
        isListFormOpen: false,
        disabled: false,
        isDisabledFields: false,
      });
      if (this.state.isViewMode) {
        let pageTitle = this.moduleCaption + " - VIEW";
        this.setState({
          isDisabledFields: true,
          disabled: true,
          pageTitle: pageTitle,
        });
      }
    } else {
      this.setState({
        isDisabledFields: true,
        disabled: true,
      });
    }
    if (this.state.moduleKeyCode != NEW_ENTRY) {
      this.setState({ disabled: true });
    }
    let locData = this.state.locData;
    let moduleOrderStatus = this.state.moduleOrderStatus;
    let status = ModuleUtils.getLetterOfCreditStatusCaption(locData.status);
    if (status !== undefined && status !== null) {
      moduleOrderStatus = status;
    }
    this.setState({ moduleOrderStatus: moduleOrderStatus });
    this.state.moduleOrderStatus = moduleOrderStatus;
    if (locData.isFetched) {
      this.setState({
        isDisabledFields: true,
      });
    }
  }

  closeEntryForm = () => {
    this.closeAllNodeViews();
    let pageTitle = this.moduleCaption;
    this.setState({
      isListFormOpen: true,
      isEntryFormOpen: false,
      isShowSaveButton: false,
      isShowApproveButton: false,
      isShowClearCriteriaButton: false,
      isShowBackButton: false,
      isShowClearErrorButton: false,
      pageTitle: pageTitle,
      isShowNodes: false,
      moduleKeyCode: NEW_ENTRY,
      isShowModuleSearchContainer: false,
      disabled: false,
      isMaintenanceMode: false,
      isDisabledFields: false,
      isResetView: false,
      isViewMode: false,
      isSpecialViewMode: false,
    });
  };
  closeAllNodeViews = () => {
    this.setState({
      isShowSaveButton: false,
      isListFormOpen: false,
      isEntryFormOpen: false,
    });
  };
  getEmptyView() {
    return <div></div>;
  }
  getNodeList = () => {
    let nodeList = [];
    let headerObject = this.getEmptyView();
    let headerNode = new NodeData(
      "headerView",
      "Header",
      headerObject,
      <AlignStartVertical size={16} />,
    );
    nodeList["headerView"] = headerNode;
    this.setState({ nodeList: nodeList });
  };
  nodeOnSelect = (selectedNode) => {
    this.setState({ selectedNodeKey: selectedNode });
    if (selectedNode == "headerView") {
      this.setHeaderView();
    }
  };
  setHeaderView = () => {
    this.closeAllNodeViews();
    this.setState({
      isShowSaveButton: true,
      isEntryFormOpen: true,
      isListFormOpen: false,
    });
  };
  getHeaderView() {
    return (
      <LetterOfCreditEntryForm
        {...this.state}
        onChange={this.onChange}
        openLetterOfCreditForm={this.openLetterOfCreditForm}
        deleteLOCLine={this.deleteLOCLine}
        onVendorCodeChange={this.onVendorCodeChange}
        bankOnChange={this.bankOnChange}
        bankEnterKeyEvent={this.bankEnterKeyEvent}
        displayBankAutoCompleteList={this.displayBankAutoCompleteList}
        vendorCodeEnterKeyEventHandler={this.vendorCodeEnterKeyEventHandler}
        displayVendorAutoCompleteList={this.displayVendorAutoCompleteList}
        getLocLineDetails={this.getLocLineDetails}
        handleSortingLocLinesChange={this.handleSortingLocLinesChange}
      />
    );
  }

  resetView = () => {
    let locData = this.state.locData;

    if (this.isLocked) {
      this.isLocked = false;
      if (!this.state.isViewMode) this.unlockLoc(locData.letterOfCreditNumber);
    } else {
      this.isLocked = false;
    }
    locData = new LetterOfCreditBean();
    this.setState({
      locData: locData,
      isResetModule: true,
      moduleKeyCode: NEW_ENTRY,
      disabled: false,
      isDisabledFields: false,
      isShowAutoCompleteVendorList: false,
      vendorPageListForAutoCompleteList: new Array(),
      isShowAutoCompleteBankList: false,
      bankPageListForAutoCompleteList: new Array(),
      isShowAutoCompletePurchaseOrderList: false,
      purchaseOrderPageListForAutoCompleteList: new Array(),
      locLinesData: new Array(),
      selectedNodeKey: "headerView",
    });
    this.state.moduleKeyCode = NEW_ENTRY;
    this.code = NEW_ENTRY;
    this.state.isViewMode = false;
    this.clearLocCreditDetails();
    this.hideAlertCallBack("", false);
    this.addNewEntry();
  };

  getLocLineDetails = (rowData) => {
    let locCreditData = { ...rowData };
    this.setState({
      locCreditData: locCreditData,
    });
    this.state.locCreditData = locCreditData;

    this.openLetterOfCreditForm();
  };
  handleresponse = (response) => {
    if (response.errors != null) {
      let errMsg = "";
      let errList = [];
      response.errors.map(
        (err) => (
          (errMsg = errMsg + err.messageDescription),
          errList.push(err.messageDescription)
        ),
      );
      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
    if (response.infos != null) {
      let infoMsg = "";
      let successMsg = [];
      response.infos.map(
        (info) => (infoMsg = infoMsg + info.messageDescription),
      );
      successMsg.push(infoMsg);
      this.setState({
        alertMessage: successMsg,
        alertType: "success",
        isShowAlert: true,
      });
    }
  };
  showErrorMessage = (response) => {
    if (response.errors != null) {
      let errMsg = "";
      let errList = new Array();
      response.errors.map(
        (err) => (
          (errMsg = errMsg + err.messageDescription),
          errList.push(err.messageDescription)
        ),
      );
      this.setState({ error_list: errList });
      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };
  onChange = (e) => {
    let locData = this.state.locData;
    locData[e.target.name] = e.target.value;
    this.setState({
      locData: locData,
    });
  };
  selectButtonClick = (e) => {
    this.editLoc(this.state.moduleKeyCode);
    // this.disable();
  };
  disable = () => {
    this.setState({
      disabled: true,
    });
  };
  editLoc = (code) => {
    if (isEmptyString(code)) return;
    let readrestInput = new RestReadRequest();
    readrestInput.companyCode = this.companyCode;
    readrestInput.code = code;
    let isLockRequired = NEW_ENTRY === code ? false : true;
    readrestInput.isLockRequired = isLockRequired;
    if (SecurityAccessManager.DepositMaintenance_IsAccessible()) {
      AccountPayableService.initLetterOfCreditModule(
        readrestInput,
        this.editLocResponse,
        this.editLocError,
      );
    } else {
      let errMsg = "Access Denied";
      let errList = [];
      errList.push(errMsg);
      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };
  editLocResponse = (response) => {
    if (response.data != null) {
      let errMsg = "";
      if (response.data.lockResponse != null) {
        if (!isEmpty(response.data.lockResponse.errors)) {
          this.showErrorMessage(response.data.lockResponse);
          this.state.isViewMode = true;
        }
      }
      if (response.data.mainOperationResponse != null) {
        if (response.data.mainOperationResponse.errors != null) {
          response.data.mainOperationResponse.errors.map((err) => {
            errMsg = err.messageDescription;
          });
        }
      }
      if (response.data.additionalOperationResponse != null) {
        if (response.data.additionalOperationResponse.errors != null) {
          response.data.additionalOperationResponse.errors.map((err) => {
            errMsg = err.messageDescription;
          });
        }
      }
      if (response.data.mainOperationResponse != null) {
        if (
          errMsg !=
          " LetterOfCredit Number [" +
            this.state.moduleKeyCode +
            "] Not Read Successfully"
        ) {
          this.showErrorMessage(response.data.mainOperationResponse);
        }
      }
      if (response.data.mainOperationResponse != null) {
        if (response.data.mainOperationResponse.letterOfCreditBean != null) {
          const locData =
            response.data.mainOperationResponse.letterOfCreditBean;
          let moduleKeyCode = locData.letterOfCreditNumber;
          let pageTitle = this.moduleCaption + " - EDIT";

          this.setState({
            locLinesData: locData.creditDetails,
            locData: locData,
            pageTitle: pageTitle,
            moduleKeyCode: moduleKeyCode,
            isLoading: false,
          }, () => {
            this.openEntryForm();
          });
          this.state.locData = locData;
          this.isLocked = true;
          // this.openEntryForm();
        } else {
          this.addNewEntry();
        }
      }
    }
    this.setState({
      isLoading: false,
    });
  };
  editLocError = (error) => {
    ShowError("Error : ", error);
  };
  filterLetterOfCredit = () => {
    this.loadPage(1);
  };
  resetFilterLetterOfCredit = () => {
    let criteria = new LetterOfCreditSearchCriteria();
    criteria.companyCode = this.companyCode;
    this.state.criteria = criteria;
    this.setState({ criteria: criteria });
    this.loadPage(1);
  };
  loadFirst = () => {
    this.loadPage(1);
  };
  loadPrevious = () => {
    let currentPage = this.state.pageList.currentPage;
    let previousPage = currentPage - 1;
    this.loadPage(previousPage);
  };
  loadNext = () => {
    let currentPage = this.state.pageList.currentPage;
    let nextPage = currentPage + 1;
    this.loadPage(nextPage);
  };
  loadLast = () => {
    let pageSize = this.state.pageList.pageSize;
    let totalCount = this.state.pageList.totalCount;
    let totalPages = totalCount / pageSize;
    totalPages += totalCount % pageSize == 0 ? 0 : 1;
    this.loadPage(totalPages);
  };
  loadPage = (pageNumber) => {
    let pageList = this.state.pageList;
    let pageInput = new PageListBean();
    pageInput.pageSize = 50;
    pageInput.currentPage = pageNumber;
    if (pageList != null) pageInput.totalCount = pageList.totalCount;
    this.state.pageList = pageInput;
    this.loadLOCPage();
  };
  loadLOCPage = () => {
    let requestInput = new RestLetterOfCreditListRequest();
    requestInput.pageInput = this.state.pageList;
    requestInput.searchCriteria = this.state.criteria;
    this.setState({
      isLoading: true,
      loadingText: "Loading ..",
    });
    if (SecurityAccessManager.LetterOfCreditView_IsAccessible()) {
      AccountPayableService.getLetterOfCreditPageList(
        requestInput,
        this.loadLOCResponse,
        this.loadLOCError,
      );
    } else {
      let errMsg = "Access Denied";
      let errList = [];
      errList.push(errMsg);
      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };
  loadLOCResponse = (response) => {
    let letterOfCredits = response.data.pageList.letterOfCredits;
    this.state.pageList.totalCount = response.data.pageList.totalCount;
    this.state.pageList.currentPage = response.data.pageList.currentPage;
    this.setState({
      isLoading: false,
      locList: letterOfCredits,
    });
  };
  loadLOCError = (error) => {
    ShowError("Error : ", error);
  };
  unlockLoc = (code) => {
    let requestInput = new RestEntityUnLockRequest();
    requestInput.companyCode = this.companyCode;
    requestInput.entityCode = code;
    if (SecurityAccessManager.LetterOfCreditMaintainance_IsAccessible()) {
      AccountPayableService.unLockLetterOfCreditNumber(
        requestInput,
        this.unlockResponse,
        this.unlockError,
      );
    } else {
      let errMsg = "Access Denied";
      let errList = [];
      errList.push(errMsg);
      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };
  unlockResponse = (response) => {
    if (!isEmpty(response.data)) {
      if (response.data.isSuccess) {
        if (this.isLocked) {
          this.editLoc(this.code);
        } else {
          this.isLocked = false;
        }
      } else {
        // this.isLocked = false; optional
        if (!this.state.isReseted) this.showErrorMessage(response.data);
      }
    }
  };
  unlockError = (error) => {
    ShowError("Error : ", error);
  };
  save = () => {
    this.saveLoc();
  };
  clearError = () => {
    this.setState({ error_list: [] });
  };
  validateLocData = (data) => {
    let isValid = false;
    let err_list = [];
    let errorMessage = "";
    if (data == null) {
      let errMsg = "Invalid data ";
      errorMessage = errorMessage + errMsg;
      err_list.push(errMsg);
    } else {
      if (isEmptyString(data.vendorCode)) {
        let errMsg = "VendorCode is Required";
        errorMessage = errorMessage + errMsg;
        err_list.push(errMsg);
      }
      if (isEmptyString(data.bankCode)) {
        let errMsg = "BankCode is Required";
        errorMessage = errorMessage + errMsg;
        err_list.push(errMsg);
      }
      if (isEmptyArray(data.creditDetails)) {
        let errMsg = "No creditLines";
        errorMessage = errorMessage + errMsg;
        err_list.push(errMsg);
      }
    }
    if (err_list.length > 0) {
      isValid = false;
      this.setState({
        alertMessage: err_list,
        alertType: "danger",
        isShowAlert: true,
      });
    } else {
      isValid = true;
      this.setState({ isShowAlert: false });
    }
    return isValid;
  };
  saveLoc = () => {
    let locData = this.state.locData;
    let isValid = false;
    isValid = this.validateLocData(locData);
    if (isValid) {
      if (locData.isFetched == true) {
        if (SecurityAccessManager.LetterOfCreditUpdation_IsAccessible()) {
          AccountPayableService.updateLetterOfCredit(
            locData,
            this.saveOrUpdateLocResponse,
            this.saveLocError,
          );
        } else {
          let errMsg = "Access Denied";
          let errList = [];
          errList.push(errMsg);

          this.setState({
            alertMessage: errList,
            alertType: "danger",
            isShowAlert: true,
          });
        }
      } else if (locData.isFetched != true) {
        if (SecurityAccessManager.LetterOfCreditCreation_IsAccessible()) {
          AccountPayableService.createLetterOfCredit(
            locData,
            this.saveOrUpdateLocResponse,
            this.saveLocError,
          );
        } else {
          let errMsg = "Access Denied";
          let errList = [];
          errList.push(errMsg);

          this.setState({
            alertMessage: errList,
            alertType: "danger",
            isShowAlert: true,
          });
        }
      }
    }
  };
  saveOrUpdateLocResponse = (response) => {
    this.handleresponse(response.data);
    if (response.data != null && response.data.letterOfCreditBean != null) {
      const locData = response.data.letterOfCreditBean;
      let pageTitle = this.moduleCaption + " - EDIT";
      this.setState({
        locData: locData,
        pageTitle: pageTitle,
      });
      // this.unlockLoc(locData.letterOfCreditNumber);
      // this.editLoc(locData.letterOfCreditNumber);
      if (!this.isLocked) {
        this.editLoc(locData.letterOfCreditNumber);
      } else {
        this.code = locData.letterOfCreditNumber;
        this.unlockLoc(locData.letterOfCreditNumber);
      }
      this.setState({
        isLoading: false,
        locData: locData,
      });
    }
  };
  saveLocError = (error) => {
    ShowError("Error : ", error);
  };
  getModuleListView = () => {
    let locData = this.state.locData;
    if (locData.code === NEW_ENTRY) {
      this.closeEntryForm();
      this.loadLOCPage();
    } else {
      if (this.isLocked) {
        this.isLocked = false;
        if (!this.state.isViewMode)
          this.unlockLoc(locData.letterOfCreditNumber);
      } else {
        this.isLocked = false;
      }

      this.closeEntryForm();
      this.loadLOCPage();
    }
  };
  validateButtons = (data) => {
    let isValidData = false;
    let err_list = [];
    let errorMessage = "";
    if (data == null) {
      let errMsg = "Invalid data ";
      errorMessage = errorMessage + errMsg;
      err_list.push(errMsg);
    } else {
      if (isEmptyString(data.vendorCode)) {
        let errMsg = "VendorCode is Required";
        errorMessage = errorMessage + errMsg;
        err_list.push(errMsg);
      }
      if (isEmptyString(data.bankCode)) {
        let errMsg = "BankCode is Required";
        errorMessage = errorMessage + errMsg;
        err_list.push(errMsg);
      }
    }
    if (err_list.length > 0) {
      isValidData = false;
      this.setState({
        alertMessage: err_list,
        alertType: "danger",
        isShowAlert: true,
      });
    } else {
      isValidData = true;
      this.setState({ isShowAlert: false });
    }
    return isValidData;
  };
  openLetterOfCreditForm = () => {
    let locCreditData = this.state.locCreditData;
    let locData = this.state.locData;
    locCreditData.companyCode = this.companyCode;
    locCreditData.letterOfCreditNumber =
      this.state.locData.letterOfCreditNumber;
    let isValid = false;
    isValid = this.validateButtons(locData);
    if (isValid) {
      if (!locCreditData.isFetched) {
        this.setState({
          isDisabledFields: false,
        });
      }
      this.setState({
        isShowLocPopup: true,
        locCreditData: locCreditData,
      });
    }
  };
  deleteLOCLine = (rowData) => {};
  handleSortingChange = (accessor) => {
    let sortField = accessor;
    let order = this.state.order;
    let sortOrder = accessor === sortField && order === "asc" ? "desc" : "asc";
    this.setState({
      order: sortOrder,
      sortField: sortField,
    });
    this.handleSorting(sortField, sortOrder);
  };
  handleSorting = (sortField, sortOrder) => {
    let list = this.state.locList;
    if (sortField && !isEmptyArray(list)) {
      const sorted = [...list].sort((a, b) => {
        if (a[sortField] === null) return 1;
        if (b[sortField] === null) return -1;
        if (a[sortField] === null && b[sortField] === null) return 0;
        return (
          a[sortField].toString().localeCompare(b[sortField].toString(), "en", {
            numeric: true,
          }) * (sortOrder === "asc" ? 1 : -1)
        );
      });
      this.setState({ locList: sorted });
    }
  };
  handleSortingLocLinesChange = (accessor) => {
    let sortField = accessor;
    let order = this.state.order;
    let sortOrder = accessor === sortField && order === "asc" ? "desc" : "asc";
    this.setState({
      order: sortOrder,
      sortField: sortField,
    });
    this.handleSortingLocLines(sortField, sortOrder);
  };
  handleSortingLocLines = (sortField, sortOrder) => {
    let list = this.state.locLinesData;
    if (sortField && !isEmptyArray(list)) {
      const sorted = [...list].sort((a, b) => {
        if (a[sortField] === null) return 1;
        if (b[sortField] === null) return -1;
        if (a[sortField] === null && b[sortField] === null) return 0;
        return (
          a[sortField].toString().localeCompare(b[sortField].toString(), "en", {
            numeric: true,
          }) * (sortOrder === "asc" ? 1 : -1)
        );
      });
      this.setState({ locLinesData: sorted });
    }
  };
  closeAlertModalCallBacklvl5 = (isShowPopup) => {
    this.setState({
      isShowLocPopup: isShowPopup,
      isShowAlertLvl5: isShowPopup,
      isDisabledFields: true,
    });
    this.clearLocCreditDetails();
  };
  hideAlertCallBack = (msgType, isDisplayed) => {
    this.setState({ isShowAlert: isDisplayed });
  };
  hideAlertCallBackLvl5 = (msgType, isDisplayed) => {
    this.setState({ isShowAlertLvl5: isDisplayed });
  };
  onModuleKeyCodeWithCriteriaOnChange = (e) => {
    let moduleKeyCode = this.state.moduleKeyCode;
    if (e.target.value !== NEW_ENTRY && e.target.value !== "undefined") {
      moduleKeyCode = e.target.value.toUpperCase();
    }
    this.setState({ moduleKeyCode: moduleKeyCode });
  };
  onVendorCodeChange = (e) => {
    let vendorCode = e.target.value;
    this.state.isShowAutoCompleteVendorList = true;
    let tempData = this.state.locData;
    let showAutoCompleteList = this.state.isShowAutoCompleteVendorList;
    if (isEmpty(vendorCode)) {
      this.state.isShowAutoCompleteVendorList = false;
      let showAutoCompleteList = this.state.isShowAutoCompleteVendorList;
      let tempData = this.state.locData;
      tempData.vendorCode = "";
      tempData.vendorName = "";
      let suggestion = [];
      this.setState({
        isShowAutoCompleteVendorList: showAutoCompleteList,
        locData: tempData,
        vendorPageListForAutoCompleteList: suggestion,
      });
    } else if (
      e.target.name == "vendorCode" &&
      showAutoCompleteList === true &&
      vendorCode !== ""
    ) {
      this.readVendorBySearchString(e.target.value);
    }
    tempData[e.target.name] = e.target.value.toUpperCase();
    this.setState({
      locData: tempData,
    });
  };
  vendorCodeEnterKeyEventHandler = (e) => {
    this.setState({
      isShowProgressBarPopup: true,
      progressLoadingText: "Reading Vendor",
    });
    this.readVendor(e.target.value);
    this.state.isShowAutoCompleteVendorList = false;
    let showAutoCompleteList = this.state.isShowAutoCompleteVendorList;
    this.setState({
      vendorPageListForAutoCompleteList: new Array(),
      isShowAutoCompleteVendorList: showAutoCompleteList,
    });
  };
  displayVendorAutoCompleteList = (showAutoCompleteList) => {
    this.setState({ isShowAutoCompleteVendorList: showAutoCompleteList });
  };
  readVendorBySearchString(searchString) {
    let searchCriteria = new VendorSearchCriteria();
    searchCriteria.companyCode = this.companyCode;
    searchCriteria.vendorCodeStartsWith = searchString;
    searchCriteria.vendorNameContains = searchString;
    let pageList = new PageListBean();
    pageList.pageSize = 100;
    let input = new RestVendorListRequest();
    input.searchCriteria = searchCriteria;
    input.pageInput = pageList;
    VendorService.getVendorPageList(
      input,
      this.readByVendorCodeResponse,
      this.readByVendorCodeResponseError,
    );
  }
  readByVendorCodeResponse = (response) => {
    let vendorCodeData = response.data.vendorPageList.vendors;
    let simpleAutoCompleteList = new Array();
    if (vendorCodeData.length > 0 && vendorCodeData != null) {
      vendorCodeData.map((vendorCode) => {
        let simpleItemBean = {
          code: vendorCode.code,
          description: vendorCode.description,
        };
        simpleAutoCompleteList.push(simpleItemBean);
      });
    }
    this.setState({
      vendorPageListForAutoCompleteList: simpleAutoCompleteList,
    });
  };
  readByVendorCodeResponseError = (error) => {
    ShowError("Error : ", error);
  };
  readVendorResponse = (response) => {
    if (response.data != null) {
      if (response.data.vendor != null) {
        let vendorData = response.data.vendor;
        let locData = this.state.locData;
        locData.vendorCode = vendorData.code;
        locData.vendorName = vendorData.description;
        this.setState({
          locData: locData,
        });
        let purchaseOrderLookupHandler = new PurchaseOrderLookupHandler(
          this.companyCode,
          "Purchase Order",
          locData.vendorCode,
        );
        this.setState({
          purchaseOrderLookupHandler: purchaseOrderLookupHandler,
        });
      }
    }
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  readVendorError = (error) => {
    this.ShowError(error);
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  readVendor = (vendorCode) => {
    let readrestInput = new RestReadRequest();
    readrestInput.companyCode = this.companyCode;
    readrestInput.code = vendorCode;
    if (SecurityAccessManager.LetterOfCreditMaintainance_IsAccessible()) {
      VendorService.readVendor(
        readrestInput,
        this.readVendorResponse,
        this.readVendorError,
      );
    } else {
      let errMsg = "Access Denied";
      let errList = [];
      errList.push(errMsg);

      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };

  bankOnChange = (e) => {
    let bankCode = e.target.value;
    this.state.isShowAutoCompleteBankList = true;
    let tempData = this.state.locData;
    let showAutoCompleteList = this.state.isShowAutoCompleteBankList;
    if (isEmpty(bankCode)) {
      this.state.isShowAutoCompleteBankList = false;
      let showAutoCompleteList = this.state.isShowAutoCompleteBankList;
      let tempData = this.state.locData;
      tempData.bankCode = "";
      tempData.bankName = "";
      let suggestion = [];
      this.setState({
        isShowAutoCompleteList: showAutoCompleteList,
        locData: tempData,
        bankPageListForAutoCompleteList: suggestion,
      });
    } else if (
      e.target.name == "bankCode" &&
      showAutoCompleteList === true &&
      bankCode !== ""
    ) {
      this.readBankBySearchString(e.target.value);
      this.readBank(e.target.value);
    }
    tempData[e.target.name] = e.target.value.toUpperCase();
    this.setState({ locData: tempData });
  };
  bankEnterKeyEvent = (e) => {
    this.readBank(e.target.value);
    this.setBankDetails(e.target.value);
    this.state.isShowAutoCompleteBankList = false;
    let showAutoCompleteList = this.state.isShowAutoCompleteBankList;
    this.setState({
      bankPageListForAutoCompleteList: new Array(),
      isShowAutoCompleteList: showAutoCompleteList,
    });
  };
  displayBankAutoCompleteList = (isShowAutoCompleteList) => {
    this.setState({
      isShowAutoCompleteBankList: isShowAutoCompleteList,
    });
  };
  readBankBySearchString = (searchString) => {
    let bankData = this.state.banks;
    let simpleAutoCompleteList = new Array();
    if (bankData.length > 0 && bankData != null) {
      bankData.map((obj) => {
        let bankBean = {
          description: obj.description,
          code: obj.code,
        };
        simpleAutoCompleteList.push(bankBean);
      });
    }

    let userInput = searchString;
    let filteredSuggestions = new Array();
    filteredSuggestions = simpleAutoCompleteList.filter(
      (list) => list.code.toLowerCase().indexOf(userInput.toLowerCase()) > -1,
    );
    this.setState({
      bankPageListForAutoCompleteList: filteredSuggestions,
    });
  };
  readBank = (bankCode) => {
    let tempData = this.state.locData;
    let bankBean = null;
    let bankData = null;
    this.state.banks.map((ln) => {
      if (ln.code === bankCode) {
        bankBean = ln;
        bankData = new BaseBean();
        bankData.code = ln.code;
        bankData.description = ln.description;
      }
    });
    if (!isEmpty(bankBean)) {
      tempData.bankCode = bankBean.code;
      this.state.isShowAutoCompleteBankList = false;
      let showAutoCompleteList = this.state.isShowAutoCompleteBankList;
      this.setState({
        locData: tempData,
        isShowAutoCompleteBankList: showAutoCompleteList,
      });
    }
  };
  setBankDetails = (value) => {
    let readrestInput = new BankAccountSearchCriteria();
    readrestInput.companyCode = this.companyCode;
    readrestInput.code = value;
    if (SecurityAccessManager.LetterOfCreditMaintainance_IsAccessible()) {
      MasterService.readBankAccount(
        readrestInput,
        this.readBankResponse,
        this.readBankError,
      );
    } else {
      let errMsg = "Access Denied";
      let errList = [];
      errList.push(errMsg);
      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };
  readBankResponse = (response) => {
    let tempLocData = this.state.locData;

    if (response.data != null && response.data.bankAccount != null) {
      const bankAccountList = response.data.bankAccount;
      tempLocData.bankCode = bankAccountList.code;
      tempLocData.bankName = bankAccountList.description;
    }
    this.setState({ locData: tempLocData });
  };
  readBankError = (error) => {
    ShowError("Error : ", error);
  };
  listOnChange = (e) => {
    let criteria = this.state.criteria;
    criteria[e.target.name] = e.target.value;
    this.setState({ criteria: criteria });
  };
  onLocCreditChange = (e) => {
    let locCreditData = this.state.locCreditData;
    locCreditData[e.target.name] = e.target.value;
    this.setState({ locCreditData: locCreditData });
  };
  onPurchaseOrderChange = (e) => {
    let purchaseOrderNumber = e.target.value;
    this.state.isShowAutoCompletePurchaseOrderList = true;
    let tempLocCreditData = this.state.locCreditData;
    let showAutoCompleteList = this.state.isShowAutoCompletePurchaseOrderList;
    if (isEmpty(purchaseOrderNumber)) {
      this.state.isShowAutoCompletePurchaseOrderList = false;
      let showAutoCompleteList = this.state.isShowAutoCompletePurchaseOrderList;
      let locCreditData = this.state.locCreditData;
      locCreditData.purchaseOrderNumber = "";
      locCreditData.purchaseOrderStartDate = "";
      locCreditData.purchaseOrderEndDate = "";
      locCreditData.purchaseOrderAmount = 0;
      let suggestion = [];
      this.setState({
        showAutoCompleteList: showAutoCompleteList,
        locCreditData: locCreditData,
        purchaseOrderPageListForAutoCompleteList: suggestion,
      });
    } else if (
      e.target.name == "purchaseOrderNumber" &&
      showAutoCompleteList === true &&
      purchaseOrderNumber !== ""
    ) {
      this.readPurchaseOrderBySearchString(e.target.value);
    }
    tempLocCreditData[e.target.name] = e.target.value;
    this.setState({ tempLocCreditData: tempLocCreditData });
  };
  readPurchaseOrderBySearchString(searchString) {
    let searchCriteria = new PurchaseOrderSearchCriteria();
    searchCriteria.companyCode = this.companyCode;
    searchCriteria.purchaseOrderNumberStartsWith = searchString;
    searchCriteria.purchaseOrderNumberContains = searchString;
    let cust_pageList = new PageListBean();
    cust_pageList.pageSize = 100;
    let cust_requestInput = new RestPurchaseOrderListRequest();
    cust_requestInput.pageInput = cust_pageList;
    cust_requestInput.searchCriteria = searchCriteria;
    PurchaseOrderService.getPurchaseOrderPageList(
      cust_requestInput,
      this.readPurchaseOrderBySearchStringResponse,
      this.readPurchaseOrderBySearchStringError,
    );
  }
  readPurchaseOrderBySearchStringResponse = (response) => {
    let purchaseorderData = response.data.purchaseOrderPageList.purchaseOrders;
    let simpleAutoCompleteList = new Array();
    if (response.data.purchaseOrderPageList != null) {
      if (purchaseorderData.length > 0 && purchaseorderData != null) {
        purchaseorderData.map((po) => {
          let simpleItemBean = {
            code: po.code,
            description: "",
          };
          simpleAutoCompleteList.push(simpleItemBean);
        });
      }
    }
    this.setState({
      purchaseOrderPageListForAutoCompleteList: simpleAutoCompleteList,
    });
  };
  readPurchaseOrderBySearchStringError = (error) => {
    ShowError("Error : " + error);
  };
  purchaseOrderEnterKeyEventHandler = (e) => {
    let poCode = e.target.value;
    this.readPurchaseOrder(poCode);
    this.setState({
      purchaseOrderPageListForAutoCompleteList: new Array(),
    });
  };
  readPurchaseOrder = (purchaseOrderCode) => {
    this.setState({
      isShowProgressBarPopup: true,
      progressLoadingText: "Reading PurchaseOrder ..",
    });
    let readrestInput = new RestReadRequest();
    readrestInput.companyCode = this.companyCode;
    readrestInput.code = purchaseOrderCode;
    if (SecurityAccessManager.LetterOfCreditMaintainance_IsAccessible()) {
      PurchaseOrderService.initPurchaseOrderModule(
        readrestInput,
        this.readPurchaseOrderResponse,
        this.readPurchaseOrderError,
      );
    } else {
      let errMsg = "Access Denied";
      let errList = [];
      errList.push(errMsg);
      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };
  readPurchaseOrderResponse = (response) => {
    if (
      response.data != null &&
      response.data.purchaseOrderResponse != null &&
      response.data.purchaseOrderResponse.purchaseOrder != null
    ) {
      let poBean = response.data.purchaseOrderResponse.purchaseOrder;
      if (poBean != null) {
        let locCreditData = this.state.locCreditData;
        locCreditData.purchaseOrderNumber = poBean.code;
        locCreditData.purchaseOrderStartDate = poBean.orderStartDate;
        locCreditData.purchaseOrderEndDate = poBean.orderStopDate;
        // let locData = this.state.locData;
        // locCreditData.purchaseOrderStartDate = locData.letterOfCreditDate;
        // locCreditData.purchaseOrderEndDate = locData.letterOfCreditDate;
        locCreditData.purchaseOrderAmount = poBean.grandTotalAmount;
        this.setState({
          isShowProgressBarPopup: false,
          progressLoadingText: "",
          locCreditData: locCreditData,
        });
      }
    }

    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  readPurchaseOrderError = (error) => {
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
    ShowError("Error : ", error);
  };
  displayAutoCompletePurchaseOrderList = (showAutoCompleteList) => {
    this.setState({
      isShowAutoCompletePurchaseOrderList: showAutoCompleteList,
    });
  };
  validateLOCCreditLines = (lineBean) => {
    let isValid = false;
    let err_list = [];
    let errorMessage = "";
    if (lineBean == null) {
      let errMsg = "Invalid data ";
      errorMessage = errorMessage + errMsg;
      err_list.push(errMsg);
    } else {
      if (isEmptyString(lineBean.purchaseOrderNumber)) {
        let errMsg = "purchaseOrderNumber is Required";
        errorMessage = errorMessage + errMsg;
        err_list.push(errMsg);
      }
      if (parseInt(lineBean.purchaseOrderAmount) <= 0) {
        let errMsg = "purchaseOrderAmount is Required";
        errorMessage = errorMessage + errMsg;
        err_list.push(errMsg);
      }
    }
    if (err_list.length > 0) {
      isValid = false;
      this.setState({ errorList: err_list });
      this.setState({
        alertMessage: err_list,
        alertType: "danger",
        isShowAlertLvl5: true,
        isShowAlert: false,
      });
    } else {
      isValid = true;
      this.setState({ isShowAlertLvl5: false, isShowAlert: false });
    }
    return isValid;
  };
  getLOCMaxLineNumber() {
    let maxLineNumber = 0;
    let creditLine = this.state.locData.creditDetails;
    if (creditLine.length > 0) {
      creditLine.map((line) => {
        if (line.lineNumber > maxLineNumber) {
          maxLineNumber = line.lineNumber;
        }
      });
    }
    return maxLineNumber;
  }
  addOrUpdateCheckDetail = (e) => {
    if (e.detail === 1) {
      let locData = this.state.locData;
      let locCreditData = this.state.locCreditData;
      let locLines = locData.creditDetails;
      let locLinesData = [];
      let isValid = false;
      isValid = this.validateLOCCreditLines(locCreditData);
      if (isValid) {
        var lineNumber = this.getLOCMaxLineNumber();
        let isLineFound = false;
        if (!isEmptyArray(locLines)) {
          locLines.map((line, i) => {
            if (line.purchaseOrderNumber == locCreditData.purchaseOrderNumber) {
              locCreditData.lineNumber = line.lineNumber;
              locLines[i] = locCreditData;
              isLineFound = true;
            } else if (line.lineNumber == locCreditData.lineNumber) {
              locLines[i] = locCreditData;
              isLineFound = true;
            }
          });
        }
        if (!isLineFound) {
          locCreditData.lineNumber = ++lineNumber;
          locLines.push(locCreditData);
        }
        locData.creditDetails = locLines;
        locLinesData = locData.creditDetails;
        this.setState({
          locData: locData,
          locLinesData: locLinesData,
        });
        this.closeAlertModalCallBacklvl5(false);
      }
    }
  };
  clearLocCreditDetails = () => {
    this.setState({
      locCreditData: new LetterOfCreditDetailBean(),
    });
  };
  moduleExit = () => {
    let locData = this.state.locData;
    if (locData.letterOfCreditNumber === NEW_ENTRY) {
      this.props.onModuleExit();
    } else {
      if (this.isLocked) {
        this.isLocked = false;
        if (!this.state.isViewMode)
          this.unlockLoc(locData.letterOfCreditNumber);
      } else {
        this.isLocked = false;
      }
      this.props.onModuleExit();
    }
  };
  render() {
    let locCreditData = this.state.locCreditData;
    let moduleOrderStatus = this.state.moduleOrderStatus;
    let isDisabledAmount = false;
    return (
      <div>
        <ProgressBar
          progressLoadingText={this.state.progressLoadingText}
          isShowPopup={this.state.isShowProgressBarPopup}
        />
        {!this.state.isSpecialViewMode ? (
          <AlertToolBox
            alertMsgList={this.state.alertMessage}
            alertErrorType={this.state.alertType}
            isShowAlert={this.state.isShowAlert}
            hideAlertCallBack={this.hideAlertCallBack}
          />
        ) : null}
        <ModuleToolBar
          isShowNewButton={false}
          onNewEntry={() => this.addNewEntry()}
          onModuleExit={() => this.moduleExit()}
          resetView={() => this.resetView()}
          pageTitle={this.state.pageTitle}
          loadingText={this.state.loadingText}
          isLoading={this.state.isLoading}
          isShowModuleSearchContainer={this.state.isShowModuleSearchContainer}
          isMaintenanceMode={this.state.isMaintenanceMode}
          onModuleKeyContainerButtonClick={this.editLoc}
          moduleKeyCode={this.state.moduleKeyCode}
          onModuleKeyCodeChange={this.onModuleKeyCodeChange}
          getModuleListView={this.getModuleListView}
          lookupRequired={true} //for f2 lookup
          lookupHandler={this.state.letterOfCreditLookupHandler} //for f2 lookup
          showCriteriaDialog={true} //for f2 lookup
          onModuleKeyCodeWithCriteriaOnChange={
            this.onModuleKeyCodeWithCriteriaOnChange
          }
          selectButtonClick={this.selectButtonClick}
          disabled={this.state.disabled}
          isResetView={this.state.isResetView}
          isSpecialViewMode={this.state.isSpecialViewMode}
        />
        {!this.state.isListFormOpen &&
          this.state.isSpecialViewMode == false &&
          this.state.isViewMode == false && (
            <BaseToolBar
              save={this.save}
              clearError={this.clearError}
              isShowSaveButton={this.state.isShowSaveButton}
              isShowClearCriteriaButton={this.state.isShowClearCriteriaButton}
              isShowClearErrorButton={this.state.isShowClearErrorButton}
              pageTitle={this.state.pageTitle}
              isSpecialViewMode={this.state.isSpecialViewMode}
            />
          )}
        {this.state.isShowNodes && (
          <BaseNodeBar
            nodeList={this.state.nodeList}
            selectedNodeKey={this.state.selectedNodeKey}
            nodeOnSelect={this.nodeOnSelect}
            moduleStatus={moduleOrderStatus}
          />
        )}
        {!this.state.isShowNodes &&
          !this.state.isListFormOpen &&
          this.state.isEntryFormOpen &&
          this.getHeaderView()}
        {this.state.isShowNodes &&
          !this.state.isListFormOpen &&
          this.state.isEntryFormOpen &&
          this.getHeaderView()}
        {this.state.isListFormOpen && (
          <LetterOfCreditListForm
            {...this.state}
            editLoc={this.editLoc}
            filterLetterOfCredit={this.filterLetterOfCredit}
            resetFilterLetterOfCredit={this.resetFilterLetterOfCredit}
            loadFirst={this.loadFirst}
            loadNext={this.loadNext}
            loadPrevious={this.loadPrevious}
            loadLast={this.loadLast}
            listOnChange={this.listOnChange}
            handleSortingChange={this.handleSortingChange}
          />
        )}
        <div>
          <MultiViewPopup
            popupLvlClass={"popupSizeLevel5"}
            isModulePopup={false}
            isShowPopup={this.state.isShowLocPopup}
            closeOnEsc={false}
            closeAlertModalCallBack={this.closeAlertModalCallBacklvl5}
            title={"LOC LINE DETAIL"}
            closeOnDocumentClick={false}
            lineFunctionalityForm={this.lineFunctionalityForm}
            alertContainerBox={
              <AlertToolBox
                alertMsgList={this.state.alertMessage}
                alertErrorType={this.state.alertType}
                isShowAlert={this.state.isShowAlertLvl5}
                hideAlertCallBack={this.hideAlertCallBackLvl5}
              />
            }
            headerButtonContainer={
              <div className="floatLeft">
                <Button
                  className="header_buttons enterFocus"
                  type="submit"
                  bssize="sm"
                  onClick={(e) => this.addOrUpdateCheckDetail(e)}
                >
                  add/update{" "}
                </Button>
              </div>
            }
            content={
              <div>
                <Row>
                  <Col className="align-items-left" sm="2">
                    <FormLabel>Loc#</FormLabel>{" "}
                  </Col>
                  <Col sm="4">
                    <InputTextbox
                      name="letterOfCreditNumber"
                      onChange={this.onLocCreditChange}
                      value={locCreditData.letterOfCreditNumber}
                      disabled={true}
                    />{" "}
                  </Col>

                  <Col className="align-items-left" sm="2">
                    <FormLabel>Ln#</FormLabel>{" "}
                  </Col>
                  <Col sm="4">
                    <InputTextbox
                      name="lineNumber"
                      onChange={this.onLocCreditChange}
                      value={locCreditData.lineNumber}
                      disabled={true}
                    />{" "}
                  </Col>
                </Row>
                <Row>
                  <Col className="align-items-left" sm="1">
                    <FormLabel className="label_head">
                      LetterOfCreditDetail
                    </FormLabel>{" "}
                  </Col>
                </Row>
                <Row>
                  <Col className="align-items-left" sm="2">
                    <FormLabel>PO#</FormLabel>{" "}
                  </Col>
                  <Col sm="4">
                    {/* <InputTextbox
                      name="purchaseOrderNumber"
                      onChange={this.onLocCreditChange}
                      value={locCreditData.purchaseOrderNumber}
                      disabled={true}
                    />{" "} */}

                    <InputTextbox
                      onChange={this.onPurchaseOrderChange}
                      ref={this.purchaseOrderRef}
                      disabled={this.state.isDisabledFields}
                      name="purchaseOrderNumber"
                      placeholder="purchaseOrderNumber"
                      value={locCreditData.purchaseOrderNumber}
                      lookupRequired={true}
                      lookupHandler={this.state.purchaseOrderLookupHandler}
                      enterKeyEventHandler={
                        this.purchaseOrderEnterKeyEventHandler
                      }
                      autoCompleteListData={
                        this.state.purchaseOrderPageListForAutoCompleteList
                      }
                      enableAutoCompleteTextBox={true}
                      displayAutoCompleteList={
                        this.displayAutoCompletePurchaseOrderList
                      }
                      showAutoCompleteList={
                        this.state.isShowAutoCompletePurchaseOrderList
                      }
                      isMandatory={true}
                    ></InputTextbox>
                  </Col>

                  <Col className="align-items-left" sm="2">
                    <FormLabel>StartDate</FormLabel>{" "}
                  </Col>
                  <Col sm="4">
                    <DatePickerComponent
                      name="purchaseOrderStartDate"
                      onChange={this.onLocCreditChange}
                      value={locCreditData.purchaseOrderStartDate}
                      disabled={true}
                    />
                  </Col>
                </Row>

                <Row>
                  <Col className="align-items-left" sm="2">
                    <FormLabel>StopDate</FormLabel>{" "}
                  </Col>
                  <Col sm="4">
                    <DatePickerComponent
                      name="purchaseOrderEndDate"
                      onChange={this.onLocCreditChange}
                      value={locCreditData.purchaseOrderEndDate}
                      disabled={true}
                    />
                  </Col>

                  <Col className="align-items-left" sm="2">
                    <FormLabel>Amount</FormLabel>{" "}
                  </Col>
                  <Col sm="4">
                    <NumberFormatInputbox
                      name="purchaseOrderAmount"
                      onChange={this.onLocCreditChange}
                      className="summary_input text-end"
                      value={locCreditData.purchaseOrderAmount}
                      disabled={isDisabledAmount}
                      decimalScale={2}
                    />{" "}
                  </Col>
                </Row>
              </div>
            }
          />{" "}
        </div>
      </div>
    );
  }
}
class LetterOfCreditListForm extends React.Component {
  static contextType = AppContext;
  constructor(props) {
    super(props);
    this.state = {
      //
    };
    this.searchRef = React.createRef();
  }
  componentDidMount() {
    if (this.searchRef.current != null) {
      this.searchRef.current.focus();
    }
  }
  onChange = (e) => {
    this.props.listOnChange(e);
  };
  editLoc = (e, code) => {
    if (e.detail === 1) this.props.editLoc(code);
  };
  filterLetterOfCredit = (e) => {
    if (e.detail === 1) this.props.filterLetterOfCredit();
  };
  resetFilterLetterOfCredit = (e) => {
    if (e.detail === 1) this.props.resetFilterLetterOfCredit();
  };
  loadFirst = (e) => {
    if (e.detail === 1) this.props.loadFirst();
  };
  loadNext = (e) => {
    if (e.detail === 1) this.props.loadNext();
  };
  loadPrevious = (e) => {
    if (e.detail === 1) this.props.loadPrevious();
  };
  loadLast = (e) => {
    if (e.detail === 1) this.props.loadLast();
  };
  handleSortingChange = (e, accessor) => {
    if (e.detail === 1) this.props.handleSortingChange(accessor);
  };
  onKeyDown = (e) => {
    if (e.keyCode == 13) {
      this.props.filterLetterOfCredit();
    }
  };
  locPageColumns = () => {
    const columns = new Array();
    columns.push(
      new ColumnDefinition()
        .setDetails("LetterOfCredit", "letterOfCreditNumber", true)
        .setStyleDetails("left", "", "", "wt-3", "wt-3")
        .setClickDetails(true, false, this.editLoc, null),
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Vendor", "vendorCode", true)
        .setStyleDetails("left", "", "", "wt-3", "wt-3"),
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("VendorName", "vendorName", true)
        .setStyleDetails("left", "", "", "wt-3", "wt-3"),
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Status", "status", true)
        .setStyleDetails("left", "", "", "wt-3", "wt-3")
        .setStatusDetails(true, this.getCaption),
    );
    columns.push(
      new ColumnDefinition()
        .setDetails(" Created Date", "createdDate", true, false, true)
        .setStyleDetails("right", "", "", "wt-3", "wt-3"),
    );

    return columns;
  };
  getCaption = (status) => {
    return ModuleUtils.getLetterOfCreditStatusCaption(status);
  };
  render() {
    let locList = this.props.locList;
    let criteria = this.props.criteria;
    let pageList = this.props.pageList;
    let totalPages = 0;
    let pageSize = pageList.pageSize;
    let totalCount = pageList.totalCount;
    totalPages = totalCount / pageSize;
    totalPages += totalCount % pageSize == 0 ? 0 : 1;
    return (
      <div>
        <div className="secondary_module_header">
          <div className="secondary_module_header_title">
            <FormLabel className="secondary_module_search_color">
              Search
            </FormLabel>
            <span className="secondary_module_header_title_2">
              <InputTextbox
                ref={this.searchRef}
                name="letterOfCreditNumberContains"
                type="text"
                value={criteria.letterOfCreditNumberContains}
                placeholder="Enter Value to Filter.."
                onChange={this.onChange}
                onKeyDown={this.onKeyDown}
              />
            </span>
            <span className="px-2"></span>
            <Button onClick={(e) => this.filterLetterOfCredit(e)}>
              Filter
            </Button>
            <span className="px-2"></span>
            <Button onClick={(e) => this.resetFilterLetterOfCredit(e)}>
              Reset
            </Button>
          </div>
          <div className="module_header_secondary_buttons">
            <span>
              PAGE - {pageList.currentPage} OF {parseInt(totalPages)}
            </span>
            <Button
              size="sm"
              className="secondary_header_buttons"
              onClick={(e) => this.loadFirst(e)}
            >
              First
            </Button>
            <Button
              size="sm"
              className="secondary_header_buttons"
              onClick={(e) => this.loadPrevious(e)}
            >
              Previous
            </Button>
            <Button
              size="sm"
              className="secondary_header_buttons"
              onClick={(e) => this.loadNext(e)}
            >
              Next
            </Button>
            <Button
              size="sm"
              className="secondary_header_buttons"
              onClick={(e) => this.loadLast(e)}
            >
              Last
            </Button>
          </div>
        </div>
        <div className="mt-3">
          <CustomTable
            data={locList}
            columns={this.locPageColumns()}
            enableHighlight={true} // Boolean flag controlling highlight execution
            //  searchText={pickTicketCriteria.searchName} // Search input text
          />
        </div>
      </div>
    );
  }
}
class LetterOfCreditEntryForm extends React.Component {
  static contextType = AppContext;
  constructor(props) {
    super(props);
    this.vendorCodeRef = React.createRef();
    this.state = {};
  }
  componentDidMount() {
    const { appData } = this.context;
    this.companyCode = appData.companyCode;
    this.initLookupHandlers();
    this.setInputFocus();
  }
  setInputFocus() {
    if (this.vendorCodeRef.current != null) {
      this.vendorCodeRef.current.focus();
    }
  }
  initLookupHandlers = () => {
    let vendorLookupHandler = new VendorLookupHandler(
      this.companyCode,
      "Vendor",
    );
    this.setState({ vendorLookupHandler: vendorLookupHandler });
    let bankLookupHandler = new GenericAttributeLookupHandler(
      this.props.banks,
      "Bank",
    );
    this.setState({ bankLookupHandler: bankLookupHandler });
  };
  onChange = (e) => {
    this.props.onChange(e);
  };
  onVendorCodeChange = (e) => {
    this.props.onVendorCodeChange(e);
  };
  vendorCodeEnterKeyEventHandler = (e) => {
    this.props.vendorCodeEnterKeyEventHandler(e);
  };
  displayVendorAutoCompleteList = (list) => {
    this.props.displayVendorAutoCompleteList(list);
  };
  bankOnChange = (e) => {
    this.props.bankOnChange(e);
  };
  bankEnterKeyEvent = (e) => {
    this.props.bankEnterKeyEvent(e);
  };
  displayBankAutoCompleteList = (showAutoCompleteList) => {
    this.props.displayBankAutoCompleteList(showAutoCompleteList);
  };
  openLetterOfCreditForm = (e) => {
    if (e.detail === 1) this.props.openLetterOfCreditForm();
  };
  deleteLOCLine = (rowData) => {
    this.props.deleteLOCLine(rowData);
  };
  getLocLineDetails = (e, val, rowData) => {
    if (e.detail === 1) this.props.getLocLineDetails(rowData);
  };
  handleSortingLocLinesChange = (e, accessor) => {
    if (e.detail === 1) this.props.handleSortingLocLinesChange(accessor);
  };
  render() {
    let locData = this.props.locData;
    let locLinesData = this.props.locLinesData;
    const textAreaStyle = {
      height: "8em",
      width: "20em",
      resize: "none",
      padding: "3px",
      boxSizing: "border-box",
      fontSize: "15px",
    };
    return (
      <div>
        <div className="div_inline ">
          <div className="div_75_no_overflow_no_height">
            <Row>
              <Col className="align-items-left">
                <FormLabel className="label_head">
                  Letter Of Credits Details
                </FormLabel>
              </Col>
            </Row>
            <Row>
              <Col className="align-items-left" sm="1">
                <FormLabel>LOC Date</FormLabel>
              </Col>
              <Col sm="3">
                <DatePickerComponent
                  onChange={this.onChange}
                  name="letterOfCreditDate"
                  value={locData.letterOfCreditDate}
                  disabled={true}
                ></DatePickerComponent>
              </Col>
              <Col className="align-items-left" sm="1">
                <FormLabel>Vendor</FormLabel>
              </Col>
              <Col className="align-items-left" sm="3">
                {/* <InputTextbox
                  onChange={this.onChange}
                  name="vendorCode"
                  value={locData.vendorCode}
                  disabled={this.props.isDisabledFields}
                /> */}
                <InputTextbox
                  ref={this.vendorRef}
                  name="vendorCode"
                  placeholder="Enter Vendor"
                  onChange={this.onVendorCodeChange}
                  value={locData.vendorCode}
                  lookupRequired={true}
                  lookupHandler={this.state.vendorLookupHandler}
                  searchCriteriaDialog={true}
                  disabled={this.props.isDisabledFields}
                  enterKeyEventHandler={this.vendorCodeEnterKeyEventHandler}
                  autoCompleteListData={
                    this.props.vendorPageListForAutoCompleteList
                  }
                  enableAutoCompleteTextBox={true}
                  displayAutoCompleteList={this.displayVendorAutoCompleteList}
                  showAutoCompleteList={this.props.isShowAutoCompleteVendorList}
                  isMandatory={true}
                />
              </Col>
              <Col sm="4">
                <InputTextbox
                  onChange={this.onChange}
                  name="vendorName"
                  value={locData.vendorName}
                  disabled={true}
                />
              </Col>
            </Row>
            <Row>
              <Col className="align-items-left" sm="2">
                <FormLabel>Account Details</FormLabel>{" "}
              </Col>
            </Row>
            <Row>
              <Col className="align-items-left" sm="1">
                <FormLabel>Bank Code</FormLabel>{" "}
              </Col>
              <Col sm="3">
                <InputTextbox
                  onChange={this.bankOnChange}
                  placeholder="bankCode"
                  name="bankCode"
                  value={locData.bankCode}
                  lookupRequired={true}
                  lookupHandler={this.state.bankLookupHandler}
                  showCriteriaDialog={true}
                  enterKeyEventHandler={this.bankEnterKeyEvent}
                  autoCompleteListData={
                    this.props.bankPageListForAutoCompleteList
                  }
                  enableAutoCompleteTextBox={true}
                  displayAutoCompleteList={this.displayBankAutoCompleteList}
                  showAutoCompleteList={this.props.isShowAutoCompleteBankList}
                  disabled={this.props.isDisabledFields}
                  isMandatory={true}
                />
              </Col>
              <Col className="align-items-left" sm="1">
                <FormLabel>Bank Name</FormLabel>{" "}
              </Col>
              <Col className="align-items-left" sm="3">
                <InputTextbox
                  name="bankName"
                  onChange={this.onChange}
                  value={locData.bankName}
                  readOnly={true}
                />
              </Col>
              <Col className="align-items-left" sm="1">
                <FormLabel>Address</FormLabel>{" "}
              </Col>
              <Col className="align-items-left" sm="3">
                <InputTextbox
                  name="vendorBankAddress"
                  onChange={this.onChange}
                  value={locData.vendorBankAddress}
                  disabled={this.props.isDisabledFields}
                />
              </Col>
            </Row>
            <Row>
              <Col className="align-items-left" sm="1">
                <FormLabel>Loc Date</FormLabel>{" "}
              </Col>
              <Col sm="3">
                <DatePickerComponent
                  onChange={this.onChange}
                  name="letterOfCreditDate"
                  value={locData.letterOfCreditDate}
                  disabled={this.props.isDisabledFields}
                  isMandatory={true}
                ></DatePickerComponent>
              </Col>
              <Col className="align-items-left" sm="1">
                <FormLabel>TotalAmt</FormLabel>{" "}
              </Col>
              <Col sm="3">
                <NumberFormatInputbox
                  onChange={this.onChange}
                  name="letterOfCreditAmount"
                  value={locData.letterOfCreditAmount}
                  className="summary_input text-end"
                  // disabled={true}
                  decimalScale={2}
                />
              </Col>
            </Row>
          </div>
          <div className="div_25_no_overflow_no_height ">
            <Row>
              <Col className="align-items-left">
                <FormLabel>Transaction Information</FormLabel>
              </Col>
            </Row>
            <Row>
              <Col className="align-items-left">
                {" "}
                <textarea
                  style={textAreaStyle}
                  name="transactionInformation"
                  type="text"
                  onChange={this.onChange}
                  value={locData.transactionInformation}
                  disabled={this.props.isDisabledFields}
                />
              </Col>
            </Row>
          </div>
        </div>
        <div>
          {" "}
          <div className="div_Custom_3">
            <Table id="fabrics_tables">
              <thead>
                <tr>
                  <th
                    onClick={(e) =>
                      this.handleSortingLocLinesChange(e, "purchaseOrderNumber")
                    }
                  >
                    <Button
                      size="sm"
                      //  disabled={this.props.isDisabledFields}
                      onClick={(e) => this.openLetterOfCreditForm(e)}
                      id="fabric_Add_Button"
                    >
                      <AddIcon />
                    </Button>
                    {"PO"}
                    {this.props.order === "desc" &&
                    this.props.sortField === "purchaseOrderNumber" ? (
                      <span className="drp-dwn-cntr">
                        <DropDwnUp />
                      </span>
                    ) : (
                      <span className="drp-dwn-cntr">
                        <DropDwnDown />
                      </span>
                    )}
                  </th>
                  <th
                    onClick={(e) =>
                      this.handleSortingLocLinesChange(
                        e,
                        "purchaseOrderStartDate",
                      )
                    }
                  >
                    Start Date
                    {this.props.order === "desc" &&
                    this.props.sortField === "purchaseOrderStartDate" ? (
                      <span className="drp-dwn-cntr">
                        <DropDwnUp />
                      </span>
                    ) : (
                      <span className="drp-dwn-cntr">
                        <DropDwnDown />
                      </span>
                    )}
                  </th>
                  <th
                    onClick={(e) =>
                      this.handleSortingLocLinesChange(
                        e,
                        "purchaseOrderEndDate",
                      )
                    }
                  >
                    End Date
                    {this.props.order === "desc" &&
                    this.props.sortField === "purchaseOrderEndDate" ? (
                      <span className="drp-dwn-cntr">
                        <DropDwnUp />
                      </span>
                    ) : (
                      <span className="drp-dwn-cntr">
                        <DropDwnDown />
                      </span>
                    )}
                  </th>
                  <th
                    onClick={(e) =>
                      this.handleSortingLocLinesChange(e, "purchaseOrderAmount")
                    }
                  >
                    Amount
                    {this.props.order === "desc" &&
                    this.props.sortField === "purchaseOrderAmount" ? (
                      <span className="drp-dwn-cntr">
                        <DropDwnUp />
                      </span>
                    ) : (
                      <span className="drp-dwn-cntr">
                        <DropDwnDown />
                      </span>
                    )}
                  </th>
                  {/* <th></th> */}
                </tr>
              </thead>
              <tbody>
                {locLinesData.map((ln, index) => (
                  <tr key={index}>
                    <td>
                      {" "}
                      <Button
                        variant="secondry"
                        className="hyperLinkText"
                        onClick={(e) =>
                          this.getLocLineDetails(e, ln.purchaseOrderNumber, ln)
                        }
                      >
                        {ln.purchaseOrderNumber}
                      </Button>
                    </td>
                    <td>{ln.purchaseOrderStartDate}</td>
                    <td>{ln.purchaseOrderEndDate}</td>
                    <td className="text-end">{ln.purchaseOrderAmount}</td>
                    {/* <td>
                      <Button
                        onClick={() => this.deleteLOCLine(ln)}
                        disabled={this.props.isDisabledFields}
                      >
                        <DeleteIcon />
                      </Button>
                    </td> */}
                  </tr>
                ))}
              </tbody>
            </Table>
            {locLinesData.length != 0 ? null : (
              <div className="no_Data">{"NO DATA"}</div>
            )}
          </div>
        </div>
      </div>
    );
  }
}
function LetterOfCreditModule(props) {
  return (
    <div id="moduleContainer" className="module_container">
      <div className="App">
        <LetterOfCreditList {...props} name="" /> <br />
      </div>
    </div>
  );
}

export default LetterOfCreditModule;
